import { useEffect, useState } from 'react';

type Props = React.HTMLProps<HTMLScriptElement>;
export type Status = 'loading' | 'loaded' | 'error';

export const useScript = (props: Props, onLoad?: () => void) => {
  const [status, setStatus] = useState<Status>('loading');

  useEffect(() => {
    if (!props.src) {
      return;
    }

    const script = document.body.appendChild(document.createElement('script'));
    const onload = () => setStatus('loaded');
    const onerror = () => setStatus('error');

    const defer = true;

    Object.assign(script, { onload, onerror, defer, ...props });

    return () => void document.body.removeChild(script);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, Object.values(props));

  useEffect(() => void (status === 'loaded' && onLoad?.()), [onLoad, status]);

  return status;
};
